import { convert as convertJcamp } from 'jcampconverter';

/**
 *
 * @param {File} file
 * @param {object} [options={}]
 * @param {RegExp} [options.keepRecordsRegExp={}]
 * @returns
 */
export async function parseData(file, options) {
  if (!file) return { info: {}, meta: {} };
  const data = await file.text();
  let { keepRecordsRegExp = /.*/ } = options;
  let result = convertJcamp(data, {
    keepRecordsRegExp,
  });
  const firstSpectrum = result.flatten.length === 0 ? {} : result.flatten[0];
  return firstSpectrum;
}
